module.exports = {"659001001":"新城街道","659001002":"向阳街道","659001003":"红山街道","659001004":"老街街道","659001005":"东城街道","659001100":"北泉镇","659001101":"石河子镇","659001500":"兵团一五二团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/659001.json
// module id = 3150
// module chunks = 0